<!-- --------页脚-------- -->
<template>
  <footer>
    <div class="contact">
      <div class="contactInfo">
        <p v-for="(i, index) in infos"
           :key="index">
          {{i.info}}
        </p>
      </div>
      <div class="nbyobo">
        <div class="QR_Code"
             v-for="(c, index) in codeImgs"
             :key="index">
          <img :src="c.codeImg">
          <h4>{{c.versions}}</h4>
        </div>
      </div>
    </div>
    <p class="copyright"
       v-html="copyright"></p>
  </footer>
</template>

<script>
export default {
  name: "myFooter",
  data () {
    return {
      infos: [
        { info: '成都天下医森数字科技有限公司' },
        /*{info: '电话：028 - 85315618'},*/
        { info: '邮箱：kefu@tianxia120.com' },
        { info: '地址：成都高新区天府大道中段530号' },
        { info: '互联网药品信息服务资格证[证书编码：(川)-非经营性-2020-0033]' }
        /*{info: '本网站未发布麻醉药品、精神药品、医疗用毒性药品、放射性药品、戒毒药品和医疗机构制剂的产品信息。'}*/
      ],
      codeImgs: [
        { codeImg: '/static/images/patientCode.png', versions: '个人版' },
        { codeImg: '/static/images/doctorCode.png', versions: '医生版' },
        { codeImg: '/static/images/vipcnIco.png', versions: '公众号' }
      ],
      copyright: 'Copyright © 成都天下医森数字科技有限公司 <a href="http://beian.miit.gov.cn" target="_blank" style="display: inline-block;color: hsla(0,0%,100%,.8)">蜀ICP备17001604号-1</a>'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/myFooter.vue